import { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import { RecurrenceMenuWrapper } from './RecurrenceMenu.style';

const RecurrenceMenu = ({
  ...props
}: AppointmentForm.RecurrenceLayoutProps) => {
  const { children } = props;
  return (
    <RecurrenceMenuWrapper>
      <AppointmentForm.RecurrenceLayout {...props}>
        {children}
      </AppointmentForm.RecurrenceLayout>
    </RecurrenceMenuWrapper>
  );
};

export default RecurrenceMenu;
